
export const CGT_TYPES = [
  { value: 'Não Mapeado', label: 'Não Mapeado' },
  { value: 'Mapeado (Por Agendamento)', label: 'Mapeado (Por Agendamento)' },
  { value: 'Mapeado (Disponível)', label: 'Mapeado (Disponível)' },
]